import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../landingPage/footer";
import { Layout } from "antd";
import MetaTagContents from "../../MetaTagContents";
import CookieConsentBanner from "../cookieConsentBanner";
import DarkNavbar from "../landingPage/header/DarkNavbar";
import HeroSection from "./HeroSection/HeroSection";
import "./Homepage.scss";
import FeaturedInArticles from "./FeaturedInArticles/FeaturedInArticles";
import RealResults from "./RealResults/RealResults";
import Metrics from "../SMBLandingPage/Metrics/Metrics";
import GetStarted from "./GetStarted/GetStarted";
import OfferingCarousel from "./OfferingCarousel/OfferingCarousel";
import ProductCreationProcess from "./ProductCreationProcess/ProductCreationProcess";
import HomepageServices from "./HomepageServices/HomepageServices";
import DiscordSection from "./DiscordSection/DiscordSection";

const Homepage = () => {
    const { name, content, schemaMarkup } = MetaTagContents.LANDING_PAGE;
    const url = new URL(window.location.href);
    const utm_source = url.searchParams.get('utm_source');
    if (utm_source) {
        localStorage.setItem('utm_source', utm_source);
    }

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{MetaTagContents.LANDING_PAGE.title}</title>
                <link rel="canonical" href="https://all3d.ai/" />
                <meta name={name} content={content} />
                <script type="application/ld+json">
                    {JSON.stringify(schemaMarkup.video)}
                </script>
                <script type="application/ld+json">
                    {JSON.stringify(schemaMarkup.organization)}
                </script>
            </Helmet>
            <CookieConsentBanner />
            <DarkNavbar />
            <Layout className="top-margins">
                <HeroSection />
                <FeaturedInArticles />
                <OfferingCarousel />
                <ProductCreationProcess />
                <HomepageServices />
                <RealResults />
                <Metrics />
                <GetStarted />
                <DiscordSection />
            </Layout>
            <Footer />
        </>
    );
};

export default Homepage;
